import packageJSON from '../../package.json';

const config = {
  APPLICATION_NAME: packageJSON.name,
  APPLICATION_PATH: '/products-guidance',
  CSS_PREFIX: `${packageJSON.name}_css`,
  SCSS_PREFIX: `${packageJSON.name}_scss`,
  DEV_SERVER_PORT: '3000',
  APP_NAME: 'Product Support',
  BRAND_NAME: 'Signant SmartSignals',
} as const;

export default config;

export const {
  APPLICATION_NAME,
  APPLICATION_PATH,
  CSS_PREFIX,
  SCSS_PREFIX,
  DEV_SERVER_PORT,
  APP_NAME,
  BRAND_NAME,
} = config;
